export default "__VITE_ASSET__f0f6bed3__"